import {Component } from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {Location} from "@angular/common";
import {TranslationService} from "./presentation/translation/TranslationService";
import {GenericAppComponent} from "./presentation/components/generic-app";
import {NavigationService} from "./presentation/navigation/NavigationService";

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends GenericAppComponent{
    public displayBar:boolean = false;
    public isWelcomePage:boolean = false;

    public isGarage:boolean = false;
    public isTrips:boolean = false;
    public isAdmin:boolean = false;

    constructor(private router:Router,
                private location:Location,
                private translationService:TranslationService,
                private navigationService:NavigationService){
        super();
    }

    ngOnInit() {
        this.translationService.Initialize(this.location.path());
        this.router.events.subscribe((value) => {
            if(value instanceof NavigationEnd){
                this.isWelcomePage = this.IsWelcomePage(value.url);
                this.UpdateNavbar(value.url);
            }
        });

        this.HandleBarDisplay();
    }

    private HandleBarDisplay(){
        var that = this;
        $(window).scroll(function (event) {
            var scroll = $(window).scrollTop();
            if(scroll > 50) {
                that.displayBar = true;
            }else if(scroll < 10){
                that.displayBar = false;
            }
        });
    }

    private UpdateNavbar(url:string){
        if(url.includes('garage')){
            this.isGarage = true;
            this.isTrips = false;
            this.isAdmin = false;
        }else if(url.includes('trips')){
            this.isGarage = false;
            this.isTrips = true;
            this.isAdmin = false;
        }else if(url.includes('admin/')){
            this.isGarage = false;
            this.isTrips = false;
            this.isAdmin = true;
        }else{
            this.isGarage = false;
            this.isTrips = false;
            this.isAdmin = false;
        }
    }

    private IsWelcomePage(url:string): boolean{
        if(url == '/' || url == '/index'){
            return true;
        }

        for(let language of this.translationService.Languages()){
            if( url == ('/index/' + language)){
                return true;
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/app.component.ts